import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { svpApiBaseQuery } from './base-query';

export const svpApi = createApi({
    reducerPath: 'svpApi',
    baseQuery: svpApiBaseQuery,
    endpoints: () => ({}),
});
